import * as authActions from "../action/auth";
import constants from "../constants";
import _ from "lodash";
import PAGE from "./Destination";
import Constants from "../constants";
import moment from "moment";

export const BROKERAGE_UNDER_RATE = 0.35;
export const BROKERAGE_OVER_RATE = 0.18;
export const MIN_BROKERAGE = 12;
export const CLEARING_FEE = 0.0003;
export const MAX_CLEARING = 1000;
export const STAMP_DUTY = 0.1;
export const STAMP_DUTY_MAX = 1000;
export const STAMP_DUTY_WARRANT = 0.1;
export const STAMP_DUTY_WARRANT_MAX = 200;
export const SST_CHARGE = 0;
export const INTRA_DAY_RATE = 0.15;

const arrayToString = (obj, separator = ",") =>
  Object.keys(obj)
    .map((key) => obj[key])
    .join(separator);
const handleHttpError = (e, dispatch, history) => {
  const { type } = e;
  switch (type) {
    case constants.LOGOUT:
      dispatch(authActions.startLogoutRequest());
      break;
    case constants.SET_OFF:
      history.push(PAGE.DASHBOARD);
      break;
    default : break;
  }
};

const formattedPrice = (price) => {
  var parts = _.round(price, 2).toFixed(2).split(".");
  var num = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + (parts[1] ? "." + parts[1] : "");
  return num;
};

const reformattedPrice = (price) => {
  var number = Number(price.replace(/[^0-9\.]+/g, ""));
  return number;
};

const prettifyNumber = (x, displayDecimals = true, decimals = 2) => {
  if (typeof x === "undefined") {
    return "";
  }
  const number = Number(x);
  if (isNaN(number)) {
    return x;
  }
  if (displayDecimals) {
    return roundToDecimals(number, decimals).toLocaleString(undefined, { minimumFractionDigits: decimals });
  }
  return number.toLocaleString(undefined);
};

const roundToDecimals = (value, decimals = 2) => {
  if (decimals === 2) {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  } else if (decimals === 5) {
    return Math.round((Number(value) + Number.EPSILON) * 100000) / 100000;
  }
};

const roundDown = (value, decimals = 2) => {
  return Math.floor(Number(value) * 100) / 100;
};

const orderByData = (data,transactionDateOrderBy,stockNameOrderBy) => {
    if (!transactionDateOrderBy) {
      if (stockNameOrderBy === Constants.ORDER_BY_ASC) {
        return _.orderBy(data, (obj) => obj.stock_name.trim(), ["asc"]);
      }
      if (stockNameOrderBy === Constants.ORDER_BY_DESC) {
        return _.orderBy(data, (obj) => obj.stock_name.trim(), ["desc"]);
      }
      return _.orderBy(data, ["transaction_date.value"], ["asc"]);
    }
    return _.orderBy(data, ["transaction_date.value"], ["asc"]);

}

const formattedDate = (date) => {
  if(_.isEmpty(date)) {
    return '-'
  }
  return moment(date).format("DD MMM YYYY");
}

const compareDate = (date) => {
  if(_.isEmpty(date)) {
    return false
  }
  return  moment() > moment(date)
}

function formatDate(date) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = String(date.getDate()).padStart(2, '0');
  const month = months[date.getMonth()]; // Get month name
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

function formatTime(date) {
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'

  return `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
}
export default {
  handleHttpError,
  formattedPrice,
  reformattedPrice,
  arrayToString,
  roundDown,
  prettifyNumber,
  roundToDecimals,
  orderByData,
  formattedDate,
  compareDate,
  formatDate,
  formatTime
};
